import { buildAccountAllocationCsvTemplate } from './buildCsvTemplate';
import type { AccountAllocationGridReport } from './types';

const REVOKE_DELAY_MS = 1000;

export const downloadAccountAllocationCsvTemplate = (
  report: AccountAllocationGridReport,
  filename: string,
  options: Parameters<typeof buildAccountAllocationCsvTemplate>[1],
): void => {
  const csv = buildAccountAllocationCsvTemplate(report, options);

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `${filename}.csv`;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  // Revoking in the same turn cancels the download in some browsers
  window.setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY_MS);
};
